import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

const COMPLETED_COLOR = '#10B981'; // jims-green DEFAULT
const OVERDUE_COLOR = '#EF4444';   // matches the overdue KPI card

/**
 * Completed vs overdue jobs per day for the selected week.
 * @param {{data: Array<{date: string, day: string, completed: number, overdue: number}>}} props - the API's dailyBreakdown.
 */
const WeeklyActivityBar = ({ data }) => {
  const days = (Array.isArray(data) ? data : []).map((d) => ({
    day: d?.day || '',
    completed: Number(d?.completed) || 0,
    overdue: Number(d?.overdue) || 0,
  }));

  const totalCompleted = days.reduce((sum, d) => sum + d.completed, 0);
  const totalOverdue = days.reduce((sum, d) => sum + d.overdue, 0);

  if (days.length === 0 || (totalCompleted === 0 && totalOverdue === 0)) {
    return (
      <div className="text-center text-gray-500 py-12">
        <p>No jobs recorded for this week.</p>
      </div>
    );
  }

  return (
    <div role="img" aria-label={`Completed versus overdue jobs per day. ${totalCompleted} completed, ${totalOverdue} overdue this week.`}>
      <ResponsiveContainer width="100%" height={280}>
        <BarChart data={days} margin={{ top: 8, right: 8, left: -16, bottom: 0 }} barGap={4} accessibilityLayer>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" />
          <XAxis dataKey="day" tickLine={false} axisLine={false} tick={{ fontSize: 12, fill: '#6B7280' }} />
          <YAxis allowDecimals={false} tickLine={false} axisLine={false} width={40} tick={{ fontSize: 12, fill: '#6B7280' }} />
          <Tooltip cursor={{ fill: '#F3F4F6' }} contentStyle={{ borderRadius: 8, border: '1px solid #E5E7EB', fontSize: 12 }} />
          <Legend iconType="circle" wrapperStyle={{ fontSize: 12 }} />
          <Bar dataKey="completed" name="Completed" fill={COMPLETED_COLOR} radius={[4, 4, 0, 0]} maxBarSize={32} isAnimationActive={false} />
          <Bar dataKey="overdue" name="Overdue" fill={OVERDUE_COLOR} radius={[4, 4, 0, 0]} maxBarSize={32} isAnimationActive={false} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default WeeklyActivityBar;
